import * as React from "react";
import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { BASE_NAME } from "../constants/index";
import Login from "./Login";
import Register from "./Register";
import Main from "./Main.js";
import { useSelector } from "react-redux";
import StravaLogin from "components/shared/StravaLogin";

export const AppRouter = () => {
  return (
    <BrowserRouter basename={`${BASE_NAME}`}>
      <Switch>
        <Route path="/" render={(props) => <Main {...props} />} />
        {/* <Route path="/login" exact render={(props) => <Login {...props} />} />
        <Route
          path="/register"
          exact
          render={(props) => <Register {...props} />}
        />
        <Route path="/login/twitter">
          <StravaLogin></StravaLogin>
        </Route>
        <Redirect to="/login" /> */}
        <Route path="*">404</Route>
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
};
